{
  "settings": "الإعدادات",
  "yourDigitalAssistant": "مساعدك الرقمي",
  "getStarted": "الخطوات الأولى",
  "login": "تسجيل الدخول ...",
  "loggingIn": "تسجيل الدخول",
  "darkMode": "الوضع الداكن",
  "clearHistory": "امسح التاريخ",
  "historyCleared": "تم محو التاريخ",
  "changeLanguage": "لغة",
  "termsAndConditions": "الشروط والأحكام",
  "messagePlaceholder": "اكتب رسالتك هنا ...",
  "messagePlaceholderDisabled": "الكتابة معطلة ...",
  "feedbackTitle": "تقييم تجربتك",
  "feedbackPlaceholder": "أخبرنا بذلك (اختياري",
  "feedbackSend": "إرسال",
  "feedbackClose": "إغلاق",
  "sessionExpired": "انتهت جلستك بسبب عدم النشاط.",
  "startNewSession": "بدء جلسة جديدة",
  "apiError": "عفوًا ، حدث خطأ ما. نحن نعمل على إصلاح هذا في أقرب وقت ممكن.",
  "apiErrorOffline": "أنت غير متصل بالإنترنت.",
  "tryAgain": "حاول مرة أخرى",
  "startOver": "البدء من جديد",
  "chatEnded": "انتهت الدردشة",
  "chatEndedThankYou": "شكرا لك على الدردشة معنا!",
  "closeChat": "قريب",
  "startNewChat": "الدردشة مرة أخرى",
  "humanTakeoverStarted": "يتم الآن تحويلك إلى خدمة العملاء ...",
  "humanTakeoverQueued": "في انتظار الاتصال بوكيل",
  "humanTakeoverAnAgent": "وكيل",
  "humanTakeoverAgentEntered": "دخلت المحادثة",
  "humanTakeoverAgentLogout": "تركت المحادثة",
  "humanTakeoverTransfer": "يتم تحويلك إلى وكيل جديد",
  "humanTakeoverEnded": "أنت الآن تدردش مع مساعدك الرقمي",
  "version": "الإصدار",
  "formIntroText": "يرجى ملء النموذج التالي لبدء الدردشة معنا.",
  "formFirstName": "الاسم الأول",
  "formLastName": "اسم العائلة",
  "formName": "اسم النموذج",
  "formEmail": "نموذج البريد الإلكتروني",
  "formWrongEmail": "يرجى تقديم عنوان بريد إلكتروني صالح.",
  "formPhone": "هاتف",
  "formShipmentId": "معرف الشحنة",
  "formQuestion": "سؤالك",
  "formAccountNumber": "رقم الحساب (للعملاء من رجال الأعمال)",
  "formAddress": "عنوان",
  "formPostcode": "الرمز البريدي",
  "formCity": "مدينة",
  "formCountry": "بلد",
  "formSubmitButton": "بدء الدردشة",
  "formEmptyFieldError": "غير مسموح بالفراغ.",
  "formPhoneNumberValidationError": "رقم هاتف غير صالح.",
  "formInputIsBiggerThan50": "يجب ألا يتجاوز 50 حرفًا.",
  "formInputIsBiggerThan100": "يجب أن يكون 100 حرف على الأكثر.",
  "formInputIsBiggerThan2000": "يجب أن يكون 2000 حرف على الأكثر.",
  "widgetEventOnline": "رسالة DA: عودة المستخدم إلى الاتصال بالإنترنت.",
  "widgetEventHidden": "رسالة DA: القطعة مخفية.",
  "widgetEventVisible": "رسالة DA: Widget مرئية.",
  "widgetEventVisibleMinimized": "رسالة DA: Widget مرئية ، ولكنها مصغّرة.",
  "widgetEventMinimized": "رسالة DA: القطعة مصغر.",
  "widgetEventMaximized": "رسالة DA: تم تكبير الأداة.",
  "widgetEventSessionExpired": "رسالة DA: انتهت صلاحية جلسة القطعة.",
  "widgetEventHangupHuman": "رسالة DA: إنهاء المستخدم جلسة استيلاء بشرية.",
  "widgetEventUserTyping": "رسالة DA: المستخدم يكتب.",
  "fileTooLarge": "أنت تحاول إرفاق ملفات كبيرة جدًا.",
  "tooManyDiles": "أنت تحاول إرفاق عدد كبير جدًا من الملفات.",
  "fileInvalidType": "أنت تحاول إرفاق أنواع ملفات غير صالحة.",
  "attachmentsDropHere": "أفلت هنا للتحميل أو",
  "attachmentsBrowse": "تصفح ملفات",
  "attachmentsExtenstionQuantity": "pdf أو الصور (حتى 10 ملفات)",
  "attachmentsSize": "حتى 30 ميجا بايت",
  "attachmentsFailedUploading": "فشل التحميل",
  "attachmentsUploading": "تحميل ...",
  "minimizeExpandText": "الدردشة الحية معنا الآن!",
  "popupWidgetNotificationMessage": "لقد تلقيت رسالة جديدة!",
  "tabWidgetNotificationMessage": "رسالة جديدة",
  "datepickerSendButton": "يرسل"
}
